$(function() {
  return $('#locale_target').on("change", function() {
    return location.href = $("option", this).eq(this.selectedIndex).data('link-path');
  });
});